import React from 'react';
import { Helmet } from 'react-helmet';
import BlogList from '../../components/blog/BlogList';
import { spotsArticles } from '../../data/spots/articles';

const BlogHomePage = () => {
  return (
    <>
      <Helmet>
        <title>Carnet de Spots Sun-Spot - Découvrez les Plus Beaux Spots Panoramiques de France</title>
        <meta name="description" content="Le Carnet de Spots Sun-Spot : guides détaillés des plus beaux points de vue panoramiques de France. Photos, informations d'accès et conseils pratiques pour chaque spot." />
        <meta name="keywords" content="carnet spots panoramiques, points de vue France, guide panorama, spots photo France, belvédères France, vues exceptionnelles" />
        <link rel="canonical" href="https://sun-spot.app/blog" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Carnet de Spots Sun-Spot - Plus Beaux Spots Panoramiques de France" />
        <meta property="og:description" content="Découvrez notre Carnet de Spots avec guides détaillés des plus beaux points de vue panoramiques de France." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sun-spot.app/blog" />
        <meta property="og:image" content="https://sun-spot.app/android-chrome-512x512.png" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Carnet de Spots Sun-Spot - Plus Beaux Spots Panoramiques" />
        <meta name="twitter:description" content="Guides détaillés des plus beaux points de vue panoramiques de France" />
        <meta name="twitter:image" content="https://sun-spot.app/android-chrome-512x512.png" />
        
        {/* Schema.org structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "Carnet de Spots Sun-Spot",
            "description": "Guides détaillés des plus beaux points de vue panoramiques de France",
            "url": "https://sun-spot.app/blog",
            "publisher": {
              "@type": "Organization",
              "name": "Sun-Spot",
              "url": "https://sun-spot.app",
              "logo": "https://sun-spot.app/logo-192.png"
            }
            // Pas de blogPost pour l'instant - sera ajouté quand les spots seront publiés
          })}
        </script>
      </Helmet>
      
      <div className="pt-16 min-h-screen">
        <BlogList spots={spotsArticles} showTitle={true} />
        
        {/* SEO Footer Content */}
        <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {/* Container avec fond contrasté pour lisibilité jour/nuit */}
          <div className="bg-white/90 backdrop-blur-md rounded-2xl shadow-xl border border-white/20 p-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-gray-800 mb-6">
                Votre Guide des Spots Panoramiques 🌅
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Bienvenue dans le Carnet de Spots Sun-Spot, l'espace où nous partageons les plus beaux lieux pour s'évader, respirer et contempler.
                Chaque guide vous emmène à la découverte d'un panorama unique : coucher de soleil sur le lac, belvédère secret en montagne, point de vue urbain insoupçonné…
              </p>
              
              <h3 className="text-2xl font-semibold text-amber-700 mb-4 flex items-center">
                📍 Des informations pratiques claires
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Pour chaque spot, vous trouverez les coordonnées GPS, les possibilités de stationnement, les accès en transport, le niveau de difficulté de la balade, ainsi que nos conseils pour choisir le meilleur moment de la journée.
              </p>
              
              <h3 className="text-2xl font-semibold text-amber-700 mb-4 flex items-center">
                📸 Une immersion visuelle
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Nos photos haute résolution vous offrent un avant-goût fidèle du lieu, pour vous donner envie d'y aller… et d'y retourner.
              </p>
              
              <h3 className="text-2xl font-semibold text-amber-700 mb-4 flex items-center">
                🌍 Un projet communautaire
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Ces guides ne sont pas seulement des articles : ils sont la première étape vers une carte vivante et collaborative, qui grandira avec vos découvertes.
              </p>
              
              <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl p-6 border-l-4 border-amber-400 shadow-sm">
                <p className="text-amber-700 text-lg font-medium text-center leading-relaxed">
                  Que vous soyez photographe, voyageur ou simple amateur de beaux paysages, Sun-Spot est votre compagnon d'évasion.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default BlogHomePage;